import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["initialValue", "optimismFactor", "optimismIncrement", "animateOnComplete", "completionLinger", "value"];
import { NanoProgress } from '../NanoProgress';
import { AbstractProgress } from '../AbstractProgress';
import { jsx as _jsx } from "react/jsx-runtime";
export const OptimisticNanoProgress = _ref => {
  let {
      initialValue = 0,
      optimismFactor = 0.25,
      optimismIncrement = 150,
      animateOnComplete = false,
      completionLinger = 500,
      value: _value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (_value === null) {
    return null;
  }
  return /*#__PURE__*/_jsx(AbstractProgress, {
    value: _value,
    initialValue: initialValue,
    incrementFactor: optimismFactor,
    incrementInterval: optimismIncrement,
    completionLingerTime: completionLinger,
    render: ({
      done,
      value
    }) => {
      if (done && animateOnComplete) {
        return null;
      }
      return /*#__PURE__*/_jsx(NanoProgress, Object.assign({}, rest, {
        animateOnComplete: animateOnComplete,
        value: value
      }));
    }
  });
};